<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="[
      'inline-flex items-center justify-center gap-x-2 font-medium transition-colors focus:outline-none',
      sizeClasses,
      variantClasses,
      disabled && 'opacity-50 cursor-not-allowed',
    ]"
    @click="$emit('click', $event)"
  >
    <component v-if="iconLeft" :is="iconLeft" :class="iconSizeClasses" />
    <slot />
    <component v-if="iconRight" :is="iconRight" :class="iconSizeClasses" />
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: (value) =>
        [
          "primary",
          "secondary",
          "outline",
          "ghost",
          "filter",
          "toggle",
          "gradient",
        ].includes(value),
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md", "lg"].includes(value),
    },
    type: {
      type: String,
      default: "button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    iconLeft: {
      type: [String, Object, Function],
      default: null,
    },
    iconRight: {
      type: [String, Object, Function],
      default: null,
    },
  },
  emits: ["click"],
  computed: {
    sizeClasses() {
      const sizes = {
        xs: "px-2.5 py-1.5 text-xs rounded",
        sm: "px-3 py-2 text-sm rounded-md",
        md: "px-4 py-2 text-sm rounded-lg",
        lg: "px-6 py-3 text-base rounded-lg",
      };
      return sizes[this.size];
    },
    iconSizeClasses() {
      const sizes = {
        xs: "w-3 h-3",
        sm: "w-4 h-4",
        md: "w-4 h-4",
        lg: "w-5 h-5",
      };
      return sizes[this.size];
    },
    variantClasses() {
      const variants = {
        primary:
          "bg-primary text-white border border-transparent hover:bg-primary/90 focus:ring-1 focus:ring-primary",
        secondary:
          "bg-white text-neutral-text border border-neutral-light hover:bg-gray-50 focus:ring-1 focus:ring-primary focus:border-primary",
        outline:
          "bg-transparent text-neutral-text border border-neutral-light hover:bg-gray-50 focus:ring-1 focus:ring-primary focus:border-primary",
        ghost:
          "bg-transparent text-neutral-text border border-transparent hover:bg-gray-50 focus:ring-1 focus:ring-primary",
        filter: this.active
          ? "bg-primary/10 text-primary-neutral border border-primary/30 focus:ring-1 focus:ring-primary"
          : "bg-white text-neutral-text border border-neutral-light hover:bg-gray-50 focus:ring-1 focus:ring-primary focus:border-primary",
        toggle: this.active
          ? "border-primary-neutral bg-primary/5 text-primary-neutral focus:ring-1 focus:ring-primary"
          : "border-neutral-light text-neutral-light hover:bg-gray-50 focus:ring-1 focus:ring-primary focus:border-primary",
        gradient:
          "bg-btn-gradient text-white border border-transparent hover:opacity-90 focus:ring-1 focus:ring-primary",
      };
      return variants[this.variant];
    },
  },
};
</script>
